import { GetDocumentList } from "@/Assets/repository";

// Kalendoriaus seniausių dokumento metų paieška (2 sunkios užklausos) atliekama
// ne dažniau kaip kartą per TTL kiekvienai savivaldybei. Visos savivaldybės dalinasi
// tuo pačiu domenu, todėl raktas atskiriamas pagal VUE_APP_BASE_URL.
const DEFAULT_TTL_HOURS = 24;

let pending = null;

function cacheKey() {
  return "minYear:" + (process.env.VUE_APP_BASE_URL || "/");
}

function ttlMs() {
  // appconfig kraunamas tik čia: programoje jis jau įkeltas paleidžiant (http-client.js),
  // o testuose taip išvengiama sinchroninės config.json užklausos importo metu.
  const appconfig = require("@/_Services/appconfig.js").default;
  const hours = Number(appconfig && appconfig.minYearCacheHours) || DEFAULT_TTL_HOURS;
  return hours * 60 * 60 * 1000;
}

function isValidYear(year) {
  return Number.isInteger(year) && year > 1900 && year <= new Date().getFullYear();
}

function readCache() {
  try {
    const cached = JSON.parse(localStorage.getItem(cacheKey()));
    if (cached && isValidYear(cached.year) && Date.now() - cached.timestamp < ttlMs()) {
      return cached.year;
    }
  } catch (e) {
    // localStorage nepasiekiamas arba sugadintas įrašas
  }
  return null;
}

function writeCache(year) {
  try {
    localStorage.setItem(cacheKey(), JSON.stringify({ year, timestamp: Date.now() }));
  } catch (e) {
    // localStorage nepasiekiamas – metai bus ieškomi kitą kartą
  }
}

async function lookupMinYear() {
  const first = await GetDocumentList("?puslapis=1&kiekis=10");
  const count = first.data.count;
  if (!count) return null;
  const lastPage = Math.ceil(count / 10);
  const last = await GetDocumentList(`?puslapis=${lastPage}&kiekis=10`);
  const items = last.data.items;
  if (!items || !items.length) return null;
  const oldest = items[items.length - 1];
  const year = oldest.signDate ? Number(oldest.signDate.slice(0, 4)) : null;
  return isValidYear(year) ? year : null;
}

export function getMinYear() {
  const cached = readCache();
  if (cached) return Promise.resolve(cached);

  if (!pending) {
    pending = lookupMinYear()
      .then((year) => {
        if (year) writeCache(year);
        return year;
      })
      .catch(() => null)
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}
